import useFetch from "../../../../hooks/useFetch";

/**
 * Every shift, whatever its status, with its mentor counts (admin only).
 * GET /shifts
 * Returns: { success, shifts: [{ id, code, displayName, isUnrestricted, status, timings, error?,
 *            lockVersion, updatedAt, mappedMentors, activeMentors, source }] }
 *   timings is the v2 JSON ({ version: 1, days: { monday: [{ start, end, auto, minHours? }] } }),
 *   or null with `error` for a row whose timings cannot be read. source: "v2" | "legacy".
 * Answers 404 while the backend's shadow and live gates are both off.
 * @param {Object} [options] - onSuccess, onError, enabled, etc.
 * @returns {{ apiData, loading, error, refetch, mutate }}
 */
export const useFetchShifts = (options = {}) => useFetch("/shifts", { method: "get", ...options });

/**
 * One shift with every mentor mapped to it and its last 20 audit rows (admin only).
 * GET /shifts/:id
 * Returns: { success, shift (as in GET /shifts), mentors: [{ mentorId, name, weekOffDay, isActive }],
 *            audit: [{ id, action, before, after, changeNote, actorId, revertOfId, createdAt }] }
 *   mentors: active logins first, then by name.
 * Refuses: an id that is not a whole number (400), an unknown shift (404).
 * @param {number|null} shiftId - nothing is fetched while it is null
 * @param {Object} [options] - onSuccess, onError, enabled, etc.
 * @returns {{ apiData, loading, error, refetch, mutate }}
 */
export const useFetchShiftDetail = (shiftId, options = {}) =>
  useFetch(`/shifts/${shiftId}`, {
    method: "get",
    enabled: shiftId !== null && shiftId !== undefined,
    ...options,
  });

/**
 * The active shifts: what an assignment dropdown may offer (any signed-in user).
 * GET /shifts/options?for=assign
 * Returns: { success, shifts: [{ id, code, displayName, source, timings }] }
 * @param {Object} [options] - onSuccess, onError, enabled, etc.
 * @returns {{ apiData, loading, error, refetch, mutate }}
 */
export const useFetchShiftOptions = (options = {}) =>
  useFetch("/shifts/options", { method: "get", params: { for: "assign" }, ...options });
